"use strict";

var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mutationFactory = void 0;

var react_1 = __importDefault(require("react"));

var helpers_1 = require("./helpers"); // keep track of called mutation


var useMutationTracking = function () {
  var mostRecentMutation = 0;

  var generateNewMutationId = function generateNewMutationId() {
    mostRecentMutation += 1;
    return mostRecentMutation;
  };

  var isMostRecentMutation = function isMostRecentMutation(mutationId) {
    return mostRecentMutation === mutationId;
  };

  return function () {
    return {
      generateNewMutationId: generateNewMutationId,
      isMostRecentMutation: isMostRecentMutation
    };
  };
}();

var initialState = {
  called: false,
  data: null,
  error: null,
  loading: false
};

var useMutation = function useMutation(mutation) {
  var baseVariables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var baseOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var saleor = helpers_1.useSaleorClient();

  var _useMutationTracking = useMutationTracking(),
      generateNewMutationId = _useMutationTracking.generateNewMutationId,
      isMostRecentMutation = _useMutationTracking.isMostRecentMutation;

  var _react_1$default$useS = react_1.default.useState(initialState),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      result = _react_1$default$useS2[0],
      setResult = _react_1$default$useS2[1];

  var handleMutationStart = function handleMutationStart() {
    if (!result.loading) {
      setResult({
        called: true,
        data: null,
        error: null,
        loading: true
      });
    }
  };

  var handleMutationError = function handleMutationError(error, mutationId) {
    if (isMostRecentMutation(mutationId)) {
      setResult(function (prevState) {
        return Object.assign(Object.assign({}, prevState), {
          error: error,
          loading: false
        });
      });
    }
  };

  var handleMutationComplete = function handleMutationComplete(data, mutationId) {
    if (isMostRecentMutation(mutationId)) {
      setResult(function (prevState) {
        return Object.assign(Object.assign({}, prevState), {
          data: data,
          loading: false
        });
      });
    }
  };

  var runMutation = react_1.default.useCallback(function (variables, options) {
    return new Promise(function (resolve) {
      handleMutationStart();
      var mutationId = generateNewMutationId();
      var apolloVariables = Object.assign(Object.assign({}, baseVariables), variables);
      var apolloOptions = Object.assign(Object.assign({}, baseOptions), options);
      saleor.legacyAPIProxy[mutation](apolloVariables, apolloOptions).then(function (data) {
        handleMutationComplete(data.data, mutationId);
        resolve(data);
      }).catch(function (err) {
        handleMutationError(err, mutationId);
        resolve(null);
      });
    });
  }, [mutation, baseOptions]);
  return [runMutation, result];
};

exports.mutationFactory = function (mutation) {
  return function (variables, options) {
    return useMutation(mutation, variables, options);
  };
};